module.exports = __webpack_public_path__ + "img/erweima.3998f92a.png";